import { FILESPACE_CLIENT_QUERY_KEYS } from '#constants';
const FILESPACE_ENTRY_CONTENTS_BASE = FILESPACE_CLIENT_QUERY_KEYS.FilespaceDirectoryContents;
export const FilespaceEntryContentKeyFactory = {
    all: () => [FILESPACE_ENTRY_CONTENTS_BASE],
    byFilespace: (filespaceId) => [
        ...FilespaceEntryContentKeyFactory.all(),
        filespaceId,
    ],
    exact: (filespaceId, fsEntryId) => [
        ...FilespaceEntryContentKeyFactory.all(),
        filespaceId,
        fsEntryId,
    ],
};
